import { Button, Typography } from "@mui/material";

const RouteChunkErrorFallback = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 text-center">
      <Typography variant="h5" className="font-semibold text-neutral-700 mb-2">
        Unable to load this page
      </Typography>
      <Typography className="text-base text-neutral-600 max-w-prose mb-6">
        The app may have been updated while this tab was open. Reload to fetch
        the latest version.
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
};

export default RouteChunkErrorFallback;
